import TimeslotButton from "../timeslot-button/TimeslotButton";
import styles from "./PlaceholderTimeslot.module.scss";

const PlaceholderTimeslot = ({
  placeholder,
  date,
}: {
  placeholder: SessionPlaceholder;
  date?: Date;
}) => (
  <TimeslotButton
    className={styles["placeholder-timeslot"]}
    timeslotName="(New)"
    startDate={placeholder.appointment_start}
    endDate={placeholder.appointment_end}
    date={date}
    isPlaceholder
  />
);

export default PlaceholderTimeslot;
